import {createReducer, on} from '@ngrx/store';
import {HttpActionState} from '../../users/userslisting/store/users-listing.reducers';
import * as DashboardActions from './dashboard.action';
import {IDashboardRootDTO} from './dashboard.dto';


const initialState : IDashboardRootDTO = {
    dashboardSettings: null,
    dashboardSettingsState: HttpActionState.Init,    
    lastSignedDocuments: [],
    lastSignedDocumentsState: HttpActionState.Init,
    bouncedDocuments: [],
    bouncedDocumentsState: HttpActionState.Init,
    expireContracts: [],
    expireContractsState: HttpActionState.Init,
    mostActiveUsers: [],
    mostActiveUsersState: HttpActionState.Init,
    latestActivities: null,
    latestActivitiesState: HttpActionState.Init,
    mostUsedTemplates: [],
    mostUsedTemplatesState: HttpActionState.Init, 
    aboutToExpire: [],
    aboutToExpireState: HttpActionState.Init,
    unreadChatMessages: [],
    unreadChatMessagesState: HttpActionState.Init,
    forgottenDocuments: [],
    forgottenDocumentsState: HttpActionState.Init,
    autoRenewalOn: null,
    autoRenewalOnState: HttpActionState.Init,
    taskAndReminderSettings: null,
    taskAndReminderSettingsRequestState: HttpActionState.Init
}


export const dashboardReducer = createReducer(
    initialState,
    on(DashboardActions.fetchLastSignedDocuments, (state) => ({
        ...state,
        lastSignedDocumentsState: HttpActionState.Busy
    })),
    
    on(DashboardActions.fetchLastSignedDocumentsSucceeded, (state, {signedDocuments}) => ({
        ...state,
        lastSignedDocuments: signedDocuments,
        lastSignedDocumentsState: HttpActionState.Done
    })),

    on(DashboardActions.fetchLastSignedDocumentsFailed, (state) => ({
        ...state,
        lastSignedDocumentsState: HttpActionState.Failed
    })),


    on(DashboardActions.fetchEmailBouncedDocuments, (state) => ({
        ...state,
        emailBouncedDocumentsState: HttpActionState.Busy
    })),


    on(DashboardActions.fetchEmailBouncedDocumentsSucceeded, (state, {bouncedDocuments}) => ({
        ...state,
        bouncedDocuments: bouncedDocuments,
        bouncedDocumentsState: HttpActionState.Done
    })),
   
    on(DashboardActions.fetchEmailBouncedDocumentsFailed, (state) => ({
        ...state,
        bouncedDocumentsState: HttpActionState.Failed
    })),

    on(DashboardActions.fetchExpireContracts, (state) => ({
        ...state,
        expireContractsState: HttpActionState.Busy
    })),    

    on(DashboardActions.fetchExpireContractsSucceeded, (state, {contracts}) => ({
        ...state,
        expireContracts: contracts,
        expireContractsState: HttpActionState.Done
    })),    

    on(DashboardActions.fetchExpireContractsFailed, (state) => ({
        ...state,
        expireContractsState: HttpActionState.Failed
    })),

    on(DashboardActions.mostActiveUsers, (state) => ({
        ...state,
        mostActiveUsersState: HttpActionState.Busy
    })),

    on(DashboardActions.mostActiveUsersSucceeded, (state, {users}) => ({
        ...state,
        mostActiveUsers: users,
        mostActiveUsersState: HttpActionState.Done
    })),

    on(DashboardActions.mostActiveUsersFailed, (state) => ({
        ...state,
        mostActiveUsersState: HttpActionState.Failed
    })),



    on(DashboardActions.fetchDashboardSettings, (state) => ({
        ...state,
        dashboardSettingsState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchDashboardSettingsSucceeded, (state, {dashboardSettings}) => ({
        ...state,
        dashboardSettings: dashboardSettings,
        dashboardSettingsState: HttpActionState.Done
    })),

    on(DashboardActions.fetchDashboardSettingsFailed, (state) => ({
        ...state,
        dashboardSettingsState: HttpActionState.Failed
    })),

    on(DashboardActions.updateDashboardSettingSucceeded, (state, {key, value}) => ({
        ...state,
        dashboardSettings: {
            ...state.dashboardSettings,
            [key] : value
        }
    })),

    on(DashboardActions.fetchLatestActivity, (state) => ({
        ...state,
        latestActivitiesState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchLatestActivitySucceeded, (state, {activities}) => ({
        ...state,
        latestActivities: activities,
        latestActivitiesState: HttpActionState.Done
    })),

    on(DashboardActions.fetchLatestActivityFailed, (state) => ({
        ...state,
        latestActivitiesState: HttpActionState.Failed
    })),

    on(DashboardActions.fetchMostUsedTemplates, (state) => ({
        ...state,
        mostUsedTemplatesState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchMostUsedTemplatesSucceeded, (state, {templates}) => ({
        ...state,
        mostUsedTemplates: templates,
        mostUsedTemplatesState: HttpActionState.Done
    })),

    on(DashboardActions.fetchMostUsedTemplatesFailed, (state) => ({
        ...state,
        mostUsedTemplatesState: HttpActionState.Failed
    })),

    on(DashboardActions.fetchAboutToExpire, (state) => ({
        ...state,
        aboutToExpireState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchAboutToExpireSucceeded, (state, {templates}) => ({
        ...state,
        aboutToExpire: templates,
        aboutToExpireState: HttpActionState.Done
    })),

    on(DashboardActions.fetchAboutToExpireFailed, (state) => ({
        ...state,
        aboutToExpireState: HttpActionState.Failed
    })),


    on(DashboardActions.fetchUnreadChatMessages, (state) => ({
        ...state,
        unreadChatMessagesState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchUnreadChatMessagesSucceeded, (state, {templates}) => ({
        ...state,
        unreadChatMessages: templates,
        unreadChatMessagesState: HttpActionState.Done
    })),

    on(DashboardActions.fetchUnreadChatMessagesFailed, (state) => ({
        ...state,
        unreadChatMessagesState: HttpActionState.Failed
    })),

    on(DashboardActions.fetchForgottenDocuments, (state) => ({
        ...state,
        forgottenDocumentsState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchForgottenDocumentsSucceeded, (state, {templates}) => ({
        ...state,
        forgottenDocuments: templates,
        forgottenDocumentsState: HttpActionState.Done
    })),

    on(DashboardActions.fetchForgottenDocumentsFailed, (state) => ({
        ...state,
        forgottenDocumentsState: HttpActionState.Failed
    })),

    on(DashboardActions.fetchAutoRenewalOn, (state) => ({
        ...state,
        autoRenewalOnState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchAutoRenewalOnSucceeded, (state, {templates}) => ({
        ...state,
        autoRenewalOn: templates,
        autoRenewalOnState: HttpActionState.Done
    })),

    on(DashboardActions.fetchAutoRenewalOnFailed, (state) => ({
        ...state,
        autoRenewalOnState: HttpActionState.Failed
    })),

    on(DashboardActions.fetchTaskAndReminders, (state) => ({
        ...state,
        taskAndReminderSettingsRequestState: HttpActionState.Busy
    })),

    on(DashboardActions.fetchTaskAndRemindersSucceeded, (state, {taskAndReminderSettings}) => ({
        ...state,
        taskAndReminderSettings: taskAndReminderSettings,
        taskAndReminderSettingsRequestState: HttpActionState.Done
    })),

    on(DashboardActions.fetchTaskAndRemindersFailed, (state) => ({
        ...state,
        taskAndReminderSettingsRequestState: HttpActionState.Failed
    }))
)
